class CountdownTimer {
  constructor(element) {
    // console.log("Timer initializing...", element);
    this.element = element;
    this.cutOffTime = element.dataset.cutOffTime;
    this.showAfterCutOff = element.dataset.showAfterCutOff === "true";

    // Get timer elements
    this.daysElement = element.querySelector("[data-days]");
    this.hoursElement = element.querySelector("[data-hours]");
    this.minutesElement = element.querySelector("[data-minutes]");
    this.secondsElement = element.querySelector("[data-seconds]");

    // console.log("Timer elements:", {
    //   days: this.daysElement,
    //   hours: this.hoursElement,
    //   minutes: this.minutesElement,
    //   seconds: this.secondsElement,
    //   cutOffTime: this.cutOffTime,
    // });

    this.intervalId = null;
    this.initialize();
  }

  initialize() {
    // Start the timer immediately
    this.updateTimer();

    // Clear any existing interval
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    // Update every second (1000ms)
    this.intervalId = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date();
    const targetTime = this.getTargetTime();

    // Calculate time difference
    let diff = targetTime - now;

    // Check if we've passed the cutoff time
    if (diff <= 0) {
      if (!this.showAfterCutOff) {
        this.element.style.display = "none";
      }
      // Set next day's target time
      targetTime.setDate(targetTime.getDate() + 1);
      diff = targetTime - now;
    }

    // Convert to days, hours, minutes, seconds
    const totalHours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    // Update the display
    this.daysElement.textContent = this.padNumber(days);
    this.hoursElement.textContent = this.padNumber(hours);
    this.minutesElement.textContent = this.padNumber(minutes);
    this.secondsElement.textContent = this.padNumber(seconds);
  }

  getTargetTime() {
    const now = new Date();
    const [hours, minutes] = this.cutOffTime
      .split(":")
      .map((num) => parseInt(num, 10));

    const target = new Date(now);
    target.setHours(hours, minutes, 0, 0);

    // If the target time has already passed today, set it for tomorrow
    if (target < now) {
      target.setDate(target.getDate() + 1);
    }

    return target;
  }

  padNumber(number) {
    return number.toString().padStart(2, "0");
  }
}

// Initialize all countdown timers on the page
document.addEventListener("DOMContentLoaded", () => {
  //   console.log("DOM Content Loaded");
  const timers = document.querySelectorAll(".announcement-timer");
  //   console.log("Found timers:", timers.length);
  timers.forEach((timer) => new CountdownTimer(timer));
});

// Add a fallback initialization in case DOMContentLoaded already fired
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  //   console.log("Document already loaded, initializing timers");
  const timers = document.querySelectorAll(".announcement-timer");
  //   console.log("Found timers:", timers.length);
  timers.forEach((timer) => new CountdownTimer(timer));
}
